import type { ElementType, HTMLAttributes } from 'react'
import { htmlHasVisibleText, unescapeLegacyEncodedHtml } from '@/lib/landing-html'
import { sanitizePublicHtml } from '@/lib/sanitize-public-html'
import styles from './SafeLandingHtml.module.css'

type SafeLandingHtmlProps = {
  html: string | null | undefined
  as?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'button'
  variant?: 'block' | 'inline'
  className?: string
} & Omit<HTMLAttributes<HTMLElement>, 'dangerouslySetInnerHTML' | 'children'>

export function SafeLandingHtml({
  html,
  as: Tag = 'div',
  variant = 'block',
  className,
  ...rest
}: SafeLandingHtmlProps) {
  if (!htmlHasVisibleText(html)) {
    return null
  }

  const variantClass = variant === 'inline' ? styles.inline : styles.block
  const combined = className ? `${variantClass} ${className}` : variantClass
  const Element = Tag as ElementType

  return (
    <Element
      className={combined}
      dangerouslySetInnerHTML={{ __html: sanitizePublicHtml(unescapeLegacyEncodedHtml(html ?? '')) }}
      {...rest}
    />
  )
}
